import React from 'react';
import { useDispatch } from 'react-redux';
import { Header, Icon, Grid, Button, Divider } from 'semantic-ui-react';
import { useCurrentUser, authAPI } from '../../_services';
import { PasswordResetModal } from './PasswordResetModal';

export const Credentials = () => {
  const { currentUser } = useCurrentUser();

  const dispatch = useDispatch();

  const register = () => {
    authAPI.registerAuthDevice(currentUser.id, dispatch);
  };

  return (
    <React.Fragment>
      <Header as="h3">
        <Icon name="lock" />
        Login
      </Header>
      <Grid.Column width={8}>
        <Header as="h4">Username</Header>
        <Header as="h5" color="grey" style={{ marginTop: 0 }}>
          {currentUser && currentUser.user_name}
        </Header>
      </Grid.Column>
      <br />
      <Grid.Column width={8}>
        <Header as="h4">Password</Header>
        <Header as="h5" color="grey" style={{ marginTop: 0 }}>
          {currentUser && Array.from({ length: 8 }, () => '\u2022')}
        </Header>
        <PasswordResetModal />
      </Grid.Column>

      <Divider />
      <Grid.Column width={8}>
        <Button
          color="olive"
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            register();
          }}
        >
          Biometric Login Setup
        </Button>
      </Grid.Column>
    </React.Fragment>
  );
};
